import { graphql } from 'gql';

export const workOrderPriceListUer = graphql(`
    query uerWorkOrderPriceListUer(
        $skip: Int
        $take: Int
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: PriceListUerRowDataFilterInput
        $order: [PriceListUerRowDataSortInput!]
    ) {
        uerWorkOrderPriceListUer(
            skip: $skip
            take: $take
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                id
                sectionId
                sectionName
                groupId
                groupName
                groupCode
                unit
                code
                name
                chapter
                uerClassifier
                status
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    unitCostWithOther
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    unitCost
                }
                isIncludedInWorkOrder
                isIncludedInAct
                justification
                workScopes {
                    id
                    number
                    description
                }
            }

            totalCount
        }
    }
`);

export const addUerToWorkOrderFromPriceList = graphql(`
    mutation uerAddUerToWorkOrderFromPriceList(
        $chapter: ChapterEnum!
        $workOrderObjectId: Long!
        $uerBaseRowIds: [Long!]!
    ) {
        uerAddUerToWorkOrderFromPriceList(
            chapter: $chapter
            workOrderObjectId: $workOrderObjectId
            uerBaseRowIds: $uerBaseRowIds
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const addUerToActKC2PriceList = graphql(`
    mutation uerAddUerToActKC2PriceList(
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $uerInputs: [PriceListUerRowInput!]!
    ) {
        uerAddUerToActKC2PriceList(chapter: $chapter, workOrderObjectId: $workOrderObjectId, uerInputs: $uerInputs) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerWorkOrderPriceListUerCodeFilterGql = graphql(`
    query uerWorkOrderPriceListUerCodeFilter(
        $take: Int
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListUerCodeFilter(
            take: $take
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceListUerNameFilterGql = graphql(`
    query uerWorkOrderPriceListUerNameFilter(
        $take: Int
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListUerNameFilter(
            take: $take
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceListUerSectionFilterGql = graphql(`
    query uerWorkOrderPriceListUerSectionFilter(
        $take: Int
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListUerSectionFilter(
            take: $take
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceListUerSubSectionFilterGql = graphql(`
    query uerWorkOrderPriceListUerSubSectionFilter(
        $take: Int
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListUerSubSectionFilter(
            take: $take
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
